import { render, staticRenderFns } from "./word-phrase-search.vue?vue&type=template&id=94b982d0&scoped=true"
import script from "./word-phrase-search.ts?vue&type=script&lang=ts&external"
export * from "./word-phrase-search.ts?vue&type=script&lang=ts&external"
import style0 from "./word-phrase-search.less?vue&type=style&index=0&id=94b982d0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b982d0",
  null
  
)

export default component.exports